import { render, staticRenderFns } from "./PanelHealthScore.vue?vue&type=template&id=55a65c63&scoped=true"
import script from "./PanelHealthScore.vue?vue&type=script&lang=js"
export * from "./PanelHealthScore.vue?vue&type=script&lang=js"
import style0 from "./PanelHealthScore.vue?vue&type=style&index=0&id=55a65c63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a65c63",
  null
  
)

export default component.exports